<template>
  <ion-page id="cancel-subscription-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
  
        <ion-item>
          <h5>{{ t("Apple Subscriber: You can manage your subscriptions on your IOS device, go to Settings -> Subscriptions.") }}</h5>
        </ion-item>
        <ion-item>
          <h5>{{ t("Google Subscriber: You can manage your subscriptions in the Google Play Store, tap on your profile icon, tap Payments &amp; subscriptions.") }}"</h5>
        </ion-item>
        <ion-item>
          <ion-label>
            <h1>{{ cancelDescription }}</h1>
            <p>If you have problems, please contact me : henry@chessvis.com</p>
          </ion-label>
        </ion-item>
        <div v-if="deviceType == 'web' || deviceType == 'iosweb' || deviceType == androidweb">
          <ion-item>
            <ion-button expand="full" size="large" @click="get_stripe_customer_url()" >{{ t("Stripe Account Manager") }}</ion-button>
          </ion-item>
        </div>
        <div v-if="whichMenu == 'buttons'">
          <ion-item>
            <ion-button expand="full" size="large" @click="returnToButtonMenu()" >{{ t("Return to Big Button Menu") }}</ion-button>
          </ion-item>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

import { ref, watch } from 'vue';
import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { buildStyleToolbar, buildStyleTopline,availableWidthHeight }  from '@/composables/screenSize'
import { t } from '@/composables/translateText.js'

const emit = defineEmits(['next-item-click'])

const connectionStore = useConnectionStore()
const deviceType = ref(connectionStore.deviceType)
const whichMenu = localStorage.getItem("whichMenu")
const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const cancelDescription = ref(t("Web (Stripe) Subscriber: cancellation is handled by you at the Stripe Customer Portal"))
var buttonAlreadyClicked = false

 const styleOneFrame = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

 updateWidthHeights()

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

function updateWidthHeights() {
   const availableSpace = availableWidthHeight()
    const subscribePositionTop = availableSpace.topIndent
    const subscribePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const subscribeHeight = availableSpace.height - subscribePositionTop + availableSpace.topIndent
    const subscribeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = subscribeHeight + "px"
    styleOneFrame.value.width = subscribeWidth + "px"
    styleOneFrame.value.top = subscribePositionTop + "px"
    styleOneFrame.value.left = subscribePositionLeft + "px"
}

function returnToButtonMenu() {
  emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
}

 function processJsonResponse (json) {
    buttonAlreadyClicked = false
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      //console.log(" in callback",json)
      return;
    }

    if (json.hasOwnProperty("message")) {
      cancelDescription.value = json['message']
      return
    }

    const url = json['url'];

    // stripe can't run inside an iframe.
    if (window.top !== window.self) {
      // The page is inside an iframe.
      console.log("This page is inside an iframe.");
      window.open(url, '_blank');
      window.open(url);
    } 
    else {
      // The page is not inside an iframe (it's the top-level window).
      console.log("This page is not inside an iframe.");
      location.href = url
    }
  }

  function get_stripe_customer_url() {
    if (buttonAlreadyClicked)
      return
    buttonAlreadyClicked = true

    var formData = { blah : "blah"  }
    useGetData("chessvis_stripe_portal.php", formData, processJsonResponse)
  }


</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>